import { render, staticRenderFns } from "./ImportFilesModalContent.vue?vue&type=template&id=6ecf4d96"
import script from "./ImportFilesModalContent.vue?vue&type=script&lang=js"
export * from "./ImportFilesModalContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports